import * as React from 'react';

import useI18n from 'src/hooks/useI18n';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {Tooltip} from '@spaced-out/ui-design-system/lib/components/Tooltip';
import {unreadNotificationsCount} from 'src/action-creators/crm';
import {Badge} from '@spaced-out/ui-design-system/lib/components/Badge';
import {useDispatch} from 'react-redux';

import CrmNotificationsPanel from 'src/components/crm/crm-notification/crm-notifications-panel/crm-notifications-panel';

import css from 'src/components/navigation/top.css';


const CrmNotifications = () => {
  const dispatch = useDispatch();
  const [showNotificationsPanel, setShowNotificationsPanel] =
    React.useState(false);
  const [unreadCount, setUnreadCount] = React.useState(0);
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  React.useEffect(() => {
    dispatch(unreadNotificationsCount()).then((res) => {
      // @ts-expect-error - TS7006 - Parameter 'res' implicitly has an 'any' type.
      setUnreadCount(res);
    });
  }, []);

  return (
    <div>
      <Tooltip
        title={t('Notifications', 'Notifications')}
        delayMotionDuration="slowest"
        placement="bottom-end"
      >
        <Button
          iconLeftName="bell"
          onClick={() => {
            setShowNotificationsPanel(true);
            setUnreadCount(0);
          }}
          size="small"
          type="ghost"
          iconLeftType="solid"
          ariaLabel={t('Notifications', 'Notifications')}
        />
      </Tooltip>
      {unreadCount > 0 && (
        <Badge
          fill="blue"
          text={String(unreadCount)}
          classNames={{wrapper: css.messageCountBadge}}
        />
      )}
      <CrmNotificationsPanel
        open={showNotificationsPanel}
        handleClose={() => setShowNotificationsPanel(false)}
      />
    </div>
  );
};
export default CrmNotifications;
